module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "favicon-16x16.19813afb.png";